<template>
  <div
    :class="[
      'asc-data-sheet--container',
      hasFilter ? 'asc-data-sheet--hasFilter' : null,
    ]"
  >
    <slot name="header"></slot>
    <slot v-if="hasFilter" name="filter"></slot>
    <div
      v-if="getItemGroups.length"
      ref="dataSheet"
      :class="[
        'asc-data-sheet--row',
        hasFilter && hasScroll ? 'hasScroll' : null,
      ]"
    >
      <div
        v-for="(itemGroup, groupIndex) in getItemGroups"
        :key="groupIndex"
        :class="getColumnClasses"
      >
        <asc-data-cell
          v-for="(item, itemIndex) in itemGroup"
          :key="itemIndex + 1 + groupIndex * getItemsPerColumn"
          class="asc-data-cell--item"
          :index="
            hasIndex ? itemIndex + 1 + groupIndex * getItemsPerColumn : null
          "
          :text="item.text"
          :count="item.count"
          :on-cell-click="handleCellClick"
          :to="item.link"
        ></asc-data-cell>
      </div>
    </div>
    <asc-no-data v-if="getItemGroups.length === 0"></asc-no-data>
  </div>
</template>

<script>
import AscDataCell from '@/components/atoms/AscDataCell'
import AscNoData from '@/components/atoms/AscNoData'
import _ from 'lodash'

export default {
  name: 'AscDataSheet',

  components: { AscDataCell, AscNoData },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    itemsPerColumn: {
      type: Number,
      default: null,
    },
    hasIndex: {
      type: Boolean,
      default: true,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    onCellClick: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      hasScroll: false,
    }
  },

  computed: {
    getItems() {
      if (this.items && this.items.length > 0) {
        return this.hasFilter ? this.items.slice(0, 8) : this.items.slice(0, 10)
      }
      return []
    },
    getItemGroups() {
      return _.chunk(this.getItems, this.getItemsPerColumn)
    },
    getColumnClasses() {
      return {
        'asc-data-sheet--column': true,
        ['cols-' + 12 / this.getItemGroups.length]: true,
        noStretch: !this.hasFillHeight,
      }
    },
    getItemsPerColumn() {
      if (this.itemsPerColumn) return this.itemsPerColumn
      // Column Breakpoints
      if (this.getItems) {
        switch (this.getItems.length) {
          case 5: {
            return 5
          }
          case 6: {
            return 3
          }
          case 8: {
            return 4
          }
          case 9: {
            return 5
          }
          case 10: {
            return 5
          }
          default: {
            // Maxitems percolumn when hasFilter = 4 / ! = 5
            return this.hasFilter ? 4 : 5
          }
        }
      } else return 0
    },
    hasFillHeight() {
      const itemGroups = this.getItemGroups
      if (itemGroups.length === 1) return true

      let prevColumnLength = null
      let equalColumns = true
      itemGroups.forEach(function (currentColumn) {
        if (
          prevColumnLength !== null &&
          currentColumn.length !== prevColumnLength
        )
          equalColumns = false

        prevColumnLength = currentColumn.length
      })
      return equalColumns
    },
  },

  updated: function () {
    const dataSheet = this.$refs.dataSheet
    setTimeout(() => {
      // Timeout as updated hook is not considering DOM transition timeout in datacells
      this.hasScroll = dataSheet
        ? dataSheet.clientHeight < dataSheet.scrollHeight
        : false
    }, 1)
  },

  methods: {
    handleCellClick(event, text) {
      if (this.onCellClick) this.onCellClick(event, text)
    },
  },
}
</script>

<style lang="scss">
.asc-data-sheet--container {
  flex-flow: column;
  align-items: stretch;
  display: flex;
  height: 100%;

  & > div {
    flex: 0 1 auto;
  }

  .asc-header--h3 {
    color: $gray-1000 !important;
    font-size: $font-size-md;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 18px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }

  .asc-no-data--container {
    height: 100%;
  }

  .filter {
    margin-bottom: 15px;
  }

  .asc-data-sheet--row {
    display: flex;
    flex: 1 1 auto;
    overflow: auto;

    &.hasScroll {
      padding-right: 6px;
    }

    .asc-data-sheet--column {
      display: flex;
      margin-right: 8px;
      flex-flow: column;
      max-width: 100%;
      flex-grow: 1;
      padding: 0;

      &.noStretch {
        align-self: flex-start;
      }

      .asc-datacell--container {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      &:only-child {
        .asc-data-cell--item:only-child {
          .asc-datacell {
            max-height: 50%;
          }
        }
      }
    }
  }

  &.asc-data-sheet--hasFilter {
    .asc-header--h3 {
      margin-bottom: 10px;
    }

    .asc-data-sheet--row {
      margin-top: 0;

      .asc-data-sheet--column {
        margin-right: 14px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
